<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <div class="userlist-header">
        <div class="userlist-header__title">
          <v-icon dark class="mr-2">mdi-account-group</v-icon>
          <span>유저 리스트</span>
        </div>
        <v-row align="center" no-gutters class="userlist-header__search">
          <v-col cols="12" sm="4" class="pa-1">
            <v-select
              v-model="sortType"
              :items="sortTypes"
              item-text="name"
              item-value="id"
              label="정렬 타입"
              dense
              solo
              flat
              hide-details
              background-color="rgba(255,255,255,0.15)"
              dark
            ></v-select>
          </v-col>
          <v-col cols="12" sm="5" class="pa-1">
            <v-text-field
              v-model="keyword"
              label="유저 아이디 검색"
              dense
              solo
              flat
              hide-details
              background-color="rgba(255,255,255,0.15)"
              dark
              append-icon="mdi-magnify"
              @click:append="searchUser"
              @keyup.enter="searchUser"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" class="pa-1">
            <v-btn color="white" outlined dark small block @click="searchUser">
              <v-icon left small>mdi-magnify</v-icon>검색
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-data-table
        :headers="headers"
        :items="list"
        :loading="loading"
        :footer-props="{'items-per-page-options': [50, 100, -1]}"
      >
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.USER_ID }}</td>
            <td>{{ row.item.NICK }}</td>
            <td>{{ row.item.CREATE_DT }}</td>
            <td>{{ getSortVal(row.item) }}</td>
            <td>
              <v-btn class="mx-1" fab dark x-small color="indigo lighten-3" @click="goMail(row.item)">
                <v-icon>mdi-email-plus</v-icon>
              </v-btn>
              <v-btn class="mx-1" fab dark x-small color="blue darken-1" @click="goDetail(row.item)">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { pnt_factory_user } from '../../api/pnt_factory';

export default {
  name: 'PntFactoryUserList',
  data: () => ({
    loading: false,
    keyword: '',
    sortType: 'RECENT',
    list: [],
    sortTypes: [
      { id: 'RECENT', name: '최신순' },
      { id: 'GEM', name: '현재 보유 보석' },
      { id: 'EARN_GEM_TOTAL', name: '누적 획득 보석' },
    ],
    headers: [
      { text: '아이디', value: 'USER_ID' },
      { text: '닉네임', value: 'NICK' },
      { text: '가입일', value: 'CREATE_DT' },
      { text: '정렬 정보', value: 'sort_info' },
      { text: '액션', value: 'actions', sortable: false },
    ],
  }),
  created() {
    this.loadList();
  },
  watch: {
    sortType() {
      this.loadList();
    },
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        let body;
        if (this.sortType === 'RECENT') {
          body = await pnt_factory_user.get_userlist_recent({ count: 100 });
        } else {
          const type = this.sortType === 'GEM' ? 'CUR' : 'TOTAL';
          body = await pnt_factory_user.get_userlist_have_gem({ count: 100, type });
        }
        this.list = body?.user_list || body?.result || [];
      } catch (e) {
        console.error('[PntFactory UserList]', e);
      } finally {
        this.loading = false;
      }
    },
    async searchUser() {
      if (!this.keyword.trim()) { alert('검색어를 입력하세요'); return; }
      this.loading = true;
      try {
        const body = await pnt_factory_user.get_search_user_list({ keyword: this.keyword });
        this.list = body?.user_list || [];
      } catch (e) {
        console.error('[PntFactory UserList search]', e);
      } finally {
        this.loading = false;
      }
    },
    getSortVal(item) {
      if (this.sortType === 'GEM') return (item.GEM ?? 0).toLocaleString();
      if (this.sortType === 'EARN_GEM_TOTAL') return (item.TOTAL_EARN_GEM ?? 0).toLocaleString();
      return '';
    },
    goMail(item) {
      this.$router.push('/pnt_factory/mail?USER_ID=' + item.USER_ID);
    },
    goDetail(item) {
      this.$router.push('/pnt_factory/user_info?USER_ID=' + item.USER_ID);
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
.userlist-header {
  background: linear-gradient(135deg, #0277BD 0%, #039BE5 100%);
  padding: 16px;
}
.userlist-header__title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
}
</style>
